import React, { memo, useState } from 'react';
import { runOnJS, useAnimatedReaction } from 'react-native-reanimated';

import { Freeze } from '@/components/Freeze';
import { useFullScreenPagerTransition } from '@/feature/circular-pager/FullScreenPagerTransitionProvider';

import { Event } from '../event-details-sbk/types';
import { EmptyModal } from '../fantasy-event-sheets/components/EventDetailsSheetScreen';
import { SbkEventDetailsScreen } from './components/SbkEventDetailsScreen';

export const SbkEventDetailsSheetScreen = memo(
    ({ shouldFreeze, event, isActive }: { isActive: boolean; shouldFreeze: boolean; event: Event }) => {
        const [shouldRenderEventScreen, setShouldRenderEventScreen] = useState(false);
        const { sheetMountAnimationProgress } = useFullScreenPagerTransition();

        useAnimatedReaction(
            () => sheetMountAnimationProgress.value,
            current => {
                if (current !== null) {
                    // To optimize performance, keep the inactive event sheets hidden at the start of the screen transition/mount.
                    // Reveal the inactive sheets only after 70 % of the mount animation has completed.
                    if (sheetMountAnimationProgress.value > -0.7 && !shouldRenderEventScreen) {
                        runOnJS(setShouldRenderEventScreen)(true);
                    }
                }
            }
        );

        // we want to freeze the following cases:
        // 1. if the sheet is outside of the viewport (shouldFreeze is true)
        // 2. if the sheet is still mounting (shouldRenderEventScreen is false) and is not active
        const freeze = shouldFreeze || (!shouldRenderEventScreen && !isActive);

        return (
            <Freeze freeze={freeze} placeholder={<EmptyModal />}>
                <SbkEventDetailsScreen event={event} isActive={isActive} />
            </Freeze>
        );
    }
);
